"use client";

import React from "react";
import { motion, useMotionTemplate, useMotionValue, animate } from "framer-motion";

const COLORS_TOP = ["#FFB51D", "#FFA500", "#FF9500", "#FFC44D"];

export function SimplePageBackground({ children }: { children: React.ReactNode }) {
  const color = useMotionValue(COLORS_TOP[0]);

  React.useEffect(() => {
    animate(color, COLORS_TOP, {
      ease: "easeInOut",
      duration: 10,
      repeat: Infinity,
      repeatType: "mirror",
    });
  }, [color]);

  const backgroundImage = useMotionTemplate`radial-gradient(140% 120% at 50% 0%, #fff8f0 18%, ${color} 70%)`;
  const darkBackgroundImage = useMotionTemplate`radial-gradient(140% 120% at 50% 0%, #0f0a06 18%, ${color} 70%)`;

  return (
    <motion.div
      style={{ backgroundImage }}
      className="relative w-full min-h-[calc(100vh-4rem)] flex flex-col overflow-visible bg-[#fff8f0] dark:bg-neutral-950"
    >
      <div className="absolute inset-0 dark:opacity-100 opacity-0" aria-hidden>
        <motion.div
          style={{ backgroundImage: darkBackgroundImage }}
          className="w-full h-full"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-t from-white/25 via-transparent to-transparent dark:from-neutral-950/40 dark:via-transparent dark:to-transparent pointer-events-none" aria-hidden />

      <div className="relative z-10 flex-1 flex flex-col">{children}</div>
    </motion.div>
  );
}
